import { Injectable } from '@angular/core';
import {ApiService} from "../../../services/external-api/api.service";
import {ConfigurationManager} from "../../configuration-manager/configuration-manager";

@Injectable({
  providedIn: 'root'
})
export class AccountingService {

  getAccounts(accessToken: string) {
    const requestParameters = {};
    requestParameters['access_token'] = accessToken;

    return this.apiService.get(this.configurationManager.getApiUrl('apiAccountingUrl') + '/accountswithbalance', requestParameters);
  }

  getAccountOperations(accessToken: string, accountId: string) {
    const requestParameters = {};
    requestParameters['access_token'] = accessToken;
    requestParameters['accountid'] = accountId;
    requestParameters['datefrom'] = '20010101';
    requestParameters['dateto'] = '20991231';

    return this.apiService.get(this.configurationManager.getApiUrl('apiAccountingUrl') + '/transactions', requestParameters);
  }
  constructor(private apiService: ApiService, private configurationManager: ConfigurationManager) { }
}
